import type { Locale } from "./types";

const vi = {
  appName: "Iron Spotter",
  appSlogan: "Discipline Over Regret",
  appSloganFull: "Pain of discipline or Pain of regret",
  showPassword: "Hiện mật khẩu",
  hidePassword: "Ẩn mật khẩu",
  rememberMe: "Ghi nhớ đăng nhập",
  forgotPassword: "Quên mật khẩu?",
  forgotPasswordTitle: "Quên mật khẩu",
  forgotPasswordIntro: "Vì lý do bảo mật, mật khẩu chỉ được đặt lại bởi người quản lý tài khoản của bạn. Hãy gặp trực tiếp hoặc gọi điện cho người phụ trách bên dưới.",
  forgotClientTitle: "Học viên",
  forgotClientBody: "Liên hệ huấn luyện viên hoặc huấn luyện viên trưởng của phòng tập.",
  forgotCoachTitle: "Huấn luyện viên",
  forgotCoachBody: "Liên hệ huấn luyện viên trưởng của phòng tập.",
  forgotHeadCoachTitle: "Huấn luyện viên trưởng",
  forgotHeadCoachBody: "Liên hệ quản trị viên hệ thống.",
  forgotPasswordAfter: "Bạn sẽ nhận lại tên đăng nhập và một mật khẩu tạm. Lần đăng nhập tiếp theo, app sẽ yêu cầu bạn đặt mật khẩu mới.",
  backToLogin: "Quay lại đăng nhập",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  username: "Tên đăng nhập",
  password: "Mật khẩu",
  newPassword: "Mật khẩu mới",
  confirmPassword: "Nhập lại mật khẩu",
  changePassword: "Đổi mật khẩu",
  mustChangePassword: "Đây là lần đầu bạn đăng nhập. Hãy đặt mật khẩu mới.",
  passwordMismatch: "Hai mật khẩu không khớp.",
  passwordTooShort: "Mật khẩu cần ít nhất 8 ký tự.",
  invalidLogin: "Sai tên đăng nhập hoặc mật khẩu.",
  save: "Lưu",
  saved: "Đã lưu",
  cancel: "Hủy",
  create: "Tạo",
  add: "Thêm",
  edit: "Sửa",
  delete: "Xóa",
  back: "Quay lại",
  search: "Tìm kiếm",
  all: "Tất cả",
  none: "Chưa có",
  notAllowed: "Bạn không có quyền làm việc này.",
  // navigation
  navHome: "Tổng quan",
  navClients: "Học viên",
  navExercises: "Bài tập",
  navTeam: "Đội ngũ",
  navSettings: "Cài đặt",
  navMe: "Của tôi",
  admin: "Quản trị hệ thống",
  // roles
  role_head_coach: "Head coach",
  role_coach: "Coach",
  role_client: "Học viên",
  // workspace
  workspaces: "Phòng gym",
  newWorkspace: "Tạo phòng gym",
  workspaceName: "Tên phòng gym",
  slug: "Mã ngắn (dùng trong đường dẫn)",
  logoUrl: "Link logo",
  primaryColor: "Màu chủ đạo",
  branding: "Thương hiệu phòng gym",
  headCoach: "Head coach",
  personalWorkspace: "Workspace cá nhân (coach tự do)",
  noWorkspace: "Bạn chưa thuộc phòng gym nào. Liên hệ quản trị viên.",
  // accounts
  fullName: "Họ tên",
  phone: "Số điện thoại",
  contactEmail: "Email liên hệ",
  accountCreated: "Đã tạo tài khoản",
  passwordReset: "Đã đặt lại mật khẩu",
  sendCredentials: "Gửi thông tin đăng nhập",
  sendSms: "Gửi qua SMS",
  sendEmail: "Gửi qua Email",
  copy: "Sao chép",
  copied: "Đã chép",
  credentialsNote: "Mật khẩu chỉ hiện một lần. Học viên sẽ phải đổi mật khẩu khi đăng nhập lần đầu.",
  credentialsMessage: "Chào {name}, tài khoản Iron Spotter của bạn:\nĐăng nhập: {url}\nTên đăng nhập: {username}\nMật khẩu tạm: {password}",
  resetPassword: "Đặt lại mật khẩu",
  usernameTaken: "Tên đăng nhập đã có người dùng.",
  usernameInvalid: "Tên đăng nhập 3–32 ký tự: chữ thường, số, dấu chấm, gạch.",
  // team
  team: "Đội ngũ",
  addCoach: "Thêm coach",
  addHeadCoach: "Thêm head coach",
  existingUser: "Đã có tài khoản? Nhập tên đăng nhập",
  deactivate: "Tạm khóa",
  activate: "Mở lại",
  inactive: "Đã khóa",
  // clients
  clients: "Học viên",
  myClients: "Của tôi",
  newClient: "Thêm học viên",
  primaryCoach: "Coach chính",
  coaches: "Coach phụ trách",
  birthDate: "Ngày sinh",
  sex: "Giới tính",
  male: "Nam",
  female: "Nữ",
  other: "Khác",
  height: "Chiều cao (cm)",
  goals: "Mục tiêu",
  injuries: "Chấn thương / lưu ý",
  coachNotes: "Ghi chú nội bộ",
  profile: "Hồ sơ",
  noClients: "Chưa có học viên.",
  // body metrics
  bodyMetrics: "Chỉ số cơ thể",
  addMeasurement: "Ghi chỉ số",
  measuredOn: "Ngày đo",
  weight: "Cân nặng",
  bodyFat: "% mỡ",
  neck: "Cổ",
  shoulders: "Vai",
  chest: "Ngực",
  armLeft: "Tay trái",
  armRight: "Tay phải",
  waist: "Eo",
  hips: "Mông",
  thighLeft: "Đùi trái",
  thighRight: "Đùi phải",
  calf: "Bắp chân",
  note: "Ghi chú",
  optionalHint: "Không bắt buộc, điền chỉ số nào có.",
  history: "Lịch sử",
  exportCsv: "Xuất CSV",
  noMeasurements: "Chưa có lần đo nào.",
  trend: "Biểu đồ",
  // exercises
  exercises: "Thư viện bài tập",
  newExercise: "Thêm bài tập",
  muscle: "Nhóm cơ",
  primaryMuscles: "Nhóm cơ chính",
  secondaryMuscles: "Nhóm cơ phụ",
  equipment: "Dụng cụ",
  level: "Cấp độ",
  category: "Loại",
  instructions: "Hướng dẫn",
  youtubeUrl: "Link YouTube",
  exerciseImages: "Hình minh họa",
  exerciseImagesHint: "Dán link ảnh (https://), mỗi dòng một link. Ảnh tải lên sẽ đứng đầu; app hiển thị tối đa 2 ảnh.",
  uploadExerciseImage: "Tải ảnh lên",
  imageUrlInvalid: "Link ảnh không hợp lệ (phải bắt đầu bằng https://).",
  exerciseImageTooLarge: "Ảnh quá lớn sau khi nén (tối đa 300 KB). Hãy thử ảnh khác.",
  nameEn: "Tên tiếng Anh",
  nameVi: "Tên tiếng Việt",
  tags: "Tag (cách nhau bởi dấu phẩy)",
  globalLibrary: "Thư viện chung",
  gymLibrary: "Bài riêng của phòng",
  measure: "Tính theo",
  measure_reps: "Số rep",
  measure_time: "Thời gian",
  measure_distance: "Quãng đường",
  noResults: "Không tìm thấy bài nào.",
  oneStepPerLine: "Mỗi dòng là một bước",
  source: "Nguồn",
  prev: "Trước",
  next: "Sau",
  // settings
  language: "Ngôn ngữ",
  unit: "Đơn vị tạ",
  personal: "Cá nhân",
  dashboardStaff: "Hôm nay",
  statClients: "Học viên",
  statCoaches: "Coach",
  statMeasurements7d: "Lần đo 7 ngày qua",
  navSchedule: "Lịch",
  navLibrary: "Thư viện",
  navHistory: "Lịch sử",
  series: "Series",
  newSeries: "Tạo series",
  seriesName: "Tên series",
  purpose: "Mục đích",
  muscleTags: "Nhóm cơ",
  proNote: "Pro note",
  addBlock: "Thêm bài",
  addExerciseToBlock: "Ghép thêm bài",
  addSet: "Thêm set",
  remove: "Bỏ",
  moveUp: "Lên",
  moveDown: "Xuống",
  block_single: "Đơn",
  block_superset: "Superset",
  block_triset: "Triset",
  block_giant: "Giant set",
  block_circuit: "Circuit",
  rounds: "Số vòng",
  restAfterBlock: "Nghỉ sau nhóm (giây)",
  setType: "Loại set",
  set_warmup: "Khởi động",
  set_working: "Chính",
  set_drop: "Drop set",
  set_failure: "Tới failure",
  reps: "Rep",
  repsHint: "8, 8-12 hoặc AMRAP",
  seconds: "Giây",
  load: "Cường độ",
  load_none: "Không ghi",
  load_kg: "Tạ",
  load_pct_1rm: "%1RM",
  load_rm: "RM",
  load_rpe: "RPE",
  load_rir: "RIR",
  tempo: "Tempo",
  tempoHint: "4 ký tự xuống/dừng/lên/dừng, X = bùng nổ (vd 31X0)",
  rest: "Nghỉ",
  restSec: "Nghỉ (giây)",
  partial: "Partial",
  partial_none: "Không",
  partial_partial: "Chỉ partial",
  partial_full_partial: "Full + partial",
  partialOnly: "Partial",
  fullPlusPartial: "Full + partial",
  partialReps: "Số partial",
  partialNote: "Phạm vi partial",
  pickExercise: "Chọn bài tập",
  duplicate: "Nhân bản",
  noSeries: "Chưa có series.",
  onlyCreatorEdits: "Chỉ người tạo được sửa series này.",
  setsCount: "set",
  exercisesCount: "bài",
  schedule: "Lịch tập",
  assignSeries: "Giao buổi tập",
  date: "Ngày",
  time: "Giờ",
  slot: "Buổi trong ngày",
  slotN: "Buổi {n}",
  noSessions: "Chưa có buổi tập nào.",
  upcoming: "Sắp tới",
  today: "Hôm nay",
  prevWeek: "Tuần trước",
  nextWeek: "Tuần sau",
  clash: "Trùng giờ coach",
  status_planned: "Chưa tập",
  status_in_progress: "Đang tập",
  status_completed: "Đã xong",
  status_skipped: "Bỏ qua",
  editSession: "Sửa riêng buổi này",
  deleteSession: "Xóa buổi",
  startWorkout: "Bắt đầu tập",
  continueWorkout: "Tập tiếp",
  endWorkout: "Kết thúc",
  workoutDone: "Đã hoàn thành buổi tập",
  setOf: "Set {n}/{total}",
  previous: "Lần trước",
  skip: "Bỏ qua",
  coachNote: "Note của coach",
  exerciseHistory: "Lịch sử bài này",
  howTo: "Cách tập",
  tapForDetails: "Bấm vào bài để xem cách tập",
  openExercisePage: "Mở trang bài tập",
  noInstructions: "Bài này chưa có hướng dẫn chi tiết. Hỏi coach của bạn nhé.",
  workoutNoteLabel: "Coach dặn cho buổi này",
  cueForYou: "Coach dặn riêng bạn",
  cueForClient: "Lưu ý kỹ thuật riêng cho học viên",
  cueHint: "Học viên thấy lưu ý này ở mọi buổi tập có bài này.",
  cuePlaceholder: "VD: Đẩy gối ra ngoài, xuống tới song song, dùng tạ đơn 8 kg",
  cueSaved: "Đã lưu lưu ý",
  noHistory: "Chưa có lịch sử.",
  overviewMinutes: "Phút",
  trainingHistory: "Lịch sử tập",
  markSkipped: "Đánh dấu bỏ qua",
  sessionsLabel: "Buổi tập",
  editingSessionCopy: "Bạn đang sửa riêng buổi tập này, series mẫu không đổi.",
  backToSession: "Về buổi tập",
  leaveWorkout: "Thoát buổi tập",
  pauseTitle: "Tạm dừng buổi tập?",
  pauseBody: "Bạn đã ghi {done}/{total} set. Các set này đã được lưu, bạn có thể quay lại tập tiếp bất cứ lúc nào.",
  saveAndLeave: "Lưu và thoát",
  keepTraining: "Ở lại tập tiếp",
  discardWorkout: "Hủy buổi tập",
  discardTitle: "Hủy buổi tập này?",
  discardBody: "{n} set đã ghi sẽ bị xóa và không tính vào lịch sử hay tiến độ. Buổi tập quay về trạng thái chưa tập. Không thể hoàn tác.",
  discardConfirm: "Xóa và hủy buổi tập",
  restartWorkout: "Bắt đầu lại từ đầu",
  restartTitle: "Bắt đầu lại từ đầu?",
  restartBody: "{n} set đã ghi sẽ bị xóa và đồng hồ chạy lại từ 0. Không thể hoàn tác.",
  restartConfirm: "Xóa và bắt đầu lại",
  resumeTitle: "Bạn có buổi tập đang dở",
  resumeBody: "Bắt đầu lúc {time} · đã ghi {done}/{total} set.",
  finishTitle: "Hoàn thành buổi tập?",
  finishSummary: "{done}/{total} set · {min} phút",
  finishMissing: "Còn {n} set chưa ghi. Các set này sẽ được bỏ qua.",
  finishEmpty: "Bạn chưa ghi set nào. Hãy ghi ít nhất một set để lưu buổi tập, hoặc hủy nếu hôm nay không tập.",
  finishNote: "Ghi chú cho coach (không bắt buộc)",
  saveWorkout: "Lưu buổi tập",
  actionFailed: "Chưa lưu được, bạn thử lại nhé.",
  video: "Video",
  setCol: "Set",
  logCol: "Log",
  navNutrition: "Dinh dưỡng",
  nutrition: "Dinh dưỡng",
  protein: "Đạm",
  carbs: "Tinh bột",
  fat: "Béo",
  fiber: "Chất xơ (g)",
  water: "Nước (ml)",
  kcal: "kcal",
  dayType: "Áp dụng cho",
  dayType_all: "Mọi ngày",
  dayType_training: "Ngày tập",
  dayType_rest: "Ngày nghỉ",
  trainingDay: "Ngày tập",
  restDay: "Ngày nghỉ",
  effectiveFrom: "Áp dụng từ",
  nutritionTargets: "Mục tiêu dinh dưỡng",
  newTarget: "Mục tiêu mới",
  dailyTotals: "Cả ngày",
  mealsPlan: "Chia theo bữa (tuỳ chọn)",
  addMealRow: "Thêm bữa",
  mealName: "Tên bữa",
  mealPresets: "Bữa sáng,Bữa trưa,Bữa phụ,Bữa tối",
  noTarget: "Coach chưa đặt mục tiêu dinh dưỡng.",
  noTargetStaff: "Chưa có mục tiêu dinh dưỡng cho học viên này.",
  setTargets: "Đặt mục tiêu",
  kcalFromMacros: "Macro tính bằng gam. Bỏ trống kcal để tự tính (4/4/9).",
  logMeal: "Ghi bữa ăn",
  mealSlot: "Bữa",
  otherMeal: "Khác",
  foodName: "Món ăn",
  photoOptional: "Ảnh (tuỳ chọn)",
  takePhoto: "Chụp / chọn ảnh",
  removePhoto: "Bỏ ảnh",
  photoTooLarge: "Ảnh quá lớn (tối đa 5 MB).",
  photoType: "Chỉ nhận ảnh JPG, PNG hoặc WebP.",
  eaten: "Đã ăn",
  remaining: "Còn lại",
  target: "Mục tiêu",
  noMeals: "Chưa ghi bữa nào trong ngày.",
  mealEmpty: "Nhập ít nhất tên món, macro hoặc ảnh.",
  comments: "Nhận xét",
  writeComment: "Viết nhận xét…",
  send: "Gửi",
  checkIns: "Check-in hằng tuần",
  checkIn: "Check-in",
  weekOf: "Tuần từ {date}",
  energy: "Năng lượng",
  sleep: "Giấc ngủ",
  stress: "Căng thẳng",
  hunger: "Cảm giác đói",
  digestion: "Tiêu hoá",
  ratingHint: "Chấm 1–5 (1 = thấp, 5 = cao).",
  trainingAdherence: "Tập đúng lịch (%)",
  nutritionAdherence: "Ăn đúng kế hoạch (%)",
  wins: "Điều làm tốt tuần này",
  struggles: "Khó khăn",
  questions: "Câu hỏi cho coach",
  submitCheckIn: "Gửi check-in",
  checkInDue: "Bạn chưa check-in tuần này",
  checkInDone: "Đã check-in tuần này",
  reviewed: "Coach đã xem",
  pendingReview: "Chờ coach xem",
  markReviewed: "Đánh dấu đã xem",
  pendingCheckIns: "Check-in chờ xem",
  noCheckIns: "Chưa có check-in.",
  weekSummary: "Số liệu trong tuần",
  avgWeight: "Cân nặng TB",
  sessionsDone: "Buổi tập xong",
  avgKcal: "kcal TB/ngày",
  daysLogged: "Ngày có ghi bữa",
  viewAll: "Xem tất cả",
  unknown: "Có lỗi xảy ra. Hãy kiểm tra lại số liệu.",
  programs: "Chương trình",
  program: "Chương trình",
  newProgram: "Chương trình mới",
  programName: "Tên chương trình",
  description: "Mô tả",
  noPrograms: "Chưa có chương trình nào.",
  phase: "Phase",
  addPhase: "Thêm phase",
  phaseName: "Tên phase",
  weeks: "Số tuần",
  weeksN: "{n} tuần",
  dayCycle: "Lịch ngày (lặp lại)",
  cycleHint: "Lịch ngày lặp lại cho đến hết số tuần của phase. 7 ngày = lịch theo tuần.",
  addDay: "Thêm ngày",
  restOption: "Nghỉ",
  dayN: "Ngày {n}",
  dayLabel: "Nhãn (vd Push)",
  duplicatePhase: "Nhân bản phase",
  phaseWorkoutsHint: "Mỗi phase có bài tập riêng: sửa bài ở phase này không ảnh hưởng phase khác.",
  programWorkouts: "Bài tập của chương trình",
  newWorkout: "Tạo buổi tập mới…",
  editWorkout: "Sửa buổi tập",
  workoutNamePrompt: "Tên buổi tập (vd Push, Pull, Legs, Ngực + Tay sau)",
  programWorkoutBanner: "Buổi tập này thuộc chương trình {program}. Sửa ở đây sẽ áp dụng cho những lần gán chương trình sau.",
  backToProgram: "Quay lại chương trình",
  applyToPhase: "Áp dụng cho {n} buổi {workout} còn lại",
  applyToPhaseHint: "Chép bài tập, set, rep, tạ và tempo của buổi này sang các buổi {workout} chưa tập của khách trong phase hiện tại.",
  appliedToPhase: "Đã áp dụng cho các buổi còn lại trong phase.",
  coach: "Coach",
  dow1: "T2",
  dow2: "T3",
  dow3: "T4",
  dow4: "T5",
  dow5: "T6",
  dow6: "T7",
  dow7: "CN",
  scheduleWeekdays: "Theo ngày trong tuần",
  scheduleCycle: "Theo chu kỳ",
  trainingDaysHint: "Chọn ngày tập và giờ từng ngày. Các buổi Push → Pull → Legs… lần lượt rơi vào ngày tập; ngày nghỉ trong chu kỳ được bỏ qua.",
  scheduleCycleHint: "Lặp đúng chu kỳ của phase, kể cả ngày nghỉ, cùng một giờ.",
  previewSchedule: "Xem trước",
  coachBusy: "Coach đã có lịch trùng giờ:",
  pickTrainingDays: "Chọn ít nhất một ngày tập.",
  trainingTimes: "Giờ tập",
  changeTimes: "Đổi giờ tập",
  changeTimesHint: "Đổi giờ cho các buổi chưa tập từ ngày đã chọn. Ngày tập trong tuần giữ nguyên; muốn dời ngày thì dùng lịch.",
  calendar: "Lịch",
  moveHere: "Dời vào ngày này",
  moveSession: "Dời ngày",
  swapSession: "Đổi chỗ",
  pickTargetDay: "Chạm vào ngày muốn dời tới trên lịch",
  pickSwapSession: "Chạm vào ngày có buổi muốn đổi chỗ",
  shiftLater: "Lùi các buổi sau 1 ngày tập",
  shiftLaterHint: "Dùng khi học viên nghỉ đột xuất: buổi này và các buổi sau trượt sang ngày tập kế tiếp, giữ đúng thứ tự.",
  noSessionThisDay: "Không có buổi tập.",
  dayView: "Ngày",
  weekView: "Tuần",
  allCoaches: "Tất cả coach",
  minutesShort: "phút",
  duration: "Thời lượng",
  sessionsCount: "buổi",
  weekViewHint: "Số buổi bắt đầu trong mỗi giờ. Chạm để xem ngày đó. Hàng — là buổi chưa có giờ.",
  cycleSummary: "{s} buổi tập / {d} ngày · {total} buổi trong phase",
  phasesCount: "phase",
  assignProgram: "Gán chương trình",
  startDate: "Ngày bắt đầu",
  startPhase: "Bắt đầu từ phase",
  currentPhase: "Phase hiện tại",
  weekOfN: "Tuần {w}/{n}",
  switchPhase: "Đổi phase",
  fromDate: "Từ ngày",
  switchPhaseHint: "Các buổi chưa tập từ ngày này sẽ được thay bằng lịch của phase mới. Buổi đã tập được giữ lại.",
  stopProgram: "Dừng chương trình",
  stopProgramHint: "Xoá các buổi chưa tập từ ngày này.",
  programActive: "Đang tập",
  programStopped: "Đã dừng",
  programFinished: "Đã hoàn thành",
  programUpcoming: "Sắp bắt đầu",
  phaseDone: "Đã xong",
  phaseNow: "Đang tập",
  phaseNext: "Sắp tới",
  viewProgram: "Xem chương trình",
  programDeleted: "Chương trình gốc đã bị xoá nên không thể đổi phase.",
  phaseDayN: "{phase} · Ngày {n}",
  // program templates
  templateLibrary: "Thư viện chương trình mẫu",
  templateLibraryHint: "Chương trình soạn sẵn bởi Iron Spotter. Sao chép về phòng tập để chỉnh sửa và gán cho học viên.",
  templateLibraryCta: "PPL, bro split, full body, chỉnh form, bàn chân bẹt, hip mobility, dân văn phòng…",
  noTemplates: "Chưa có chương trình mẫu.",
  perWeekN: "{n} buổi/tuần",
  minutesN: "~{n} phút",
  cloneTemplate: "Sao chép về phòng tập",
  cloneTemplateHint: "Tạo một chương trình mới của bạn trong phòng tập này. Bản mẫu gốc không bị thay đổi.",
  exerciseMissing: "chưa có trong thư viện",
  templateCloned: "Đã sao chép từ mẫu. Đây là chương trình của bạn: đổi bài, set, rep thoải mái rồi gán cho học viên.",
  clonedFromTemplate: "Sao chép từ mẫu:",
  templateAdmin: "Thư viện mẫu (quản trị)",
  templateAdminHint: "Lưu nội dung chương trình này vào thư viện mẫu dùng chung cho mọi phòng tập. Chỉ dùng được bài tập trong thư viện chung.",
  updateTemplate: "Cập nhật mẫu \"{name}\"",
  updateTemplateConfirm: "Ghi đè nội dung bản mẫu bằng chương trình này? Các chương trình đã sao chép trước đó không bị ảnh hưởng.",
  publishAsNewTemplate: "Lưu thành mẫu mới",
  templateSaved: "Đã lưu vào thư viện mẫu. Mẫu mới ở trạng thái nháp cho tới khi bật hiển thị trong trang quản trị.",
  templateCustomExercise: "Chương trình có bài tập riêng của phòng tập. Hãy đổi sang bài trong thư viện chung trước khi lưu thành mẫu.",
  adminTemplatesHint: "Mẫu đang hiển thị được mọi head coach và coach nhìn thấy và sao chép. Để sửa bài tập trong mẫu, mở mẫu trong trình soạn chương trình rồi bấm \"Cập nhật mẫu\".",
  adminTemplatesCta: "Quản lý các chương trình mẫu cho mọi phòng tập",
  templatePublished: "Đang hiển thị",
  templateDraft: "Nháp",
  templateCategory: "Nhóm",
  templateLevel: "Trình độ",
  templateEquipment: "Dụng cụ",
  sessionsPerWeek: "Buổi/tuần",
  minutesPerSession: "Phút/buổi",
  sortOrder: "Thứ tự",
  templatePublishedHint: "Hiển thị cho head coach và coach",
  editTemplateContent: "Sửa bài tập trong mẫu",
  editTemplateContentHint: "Mẫu được sao chép vào phòng tập đã chọn để sửa bằng trình soạn chương trình.",
  openInBuilder: "Mở trong trình soạn",
  deleteTemplate: "Xoá mẫu {name}",
  // series templates
  seriesTemplateLibrary: "Series mẫu từ các huyền thoại",
  seriesTemplateLibraryHint: "Buổi tập soạn sẵn, phỏng theo phương pháp của các vận động viên và huấn luyện viên huyền thoại. Sao chép về phòng tập để chỉnh sửa, bản gốc luôn được giữ nguyên.",
  seriesTemplateLibraryCta: "Arnold, Dorian Yates, Mike Mentzer, Ronnie Coleman, 5/3/1, Starting Strength, Westside…",
  noSeriesTemplates: "Chưa có series mẫu.",
  inspiredBy: "Phỏng theo",
  cloneSeriesTemplateHint: "Tạo một series mới của bạn trong phòng tập này. Bản mẫu gốc không bị thay đổi.",
  seriesTemplateCloned: "Đã sao chép từ mẫu. Đây là series của bạn: đổi bài, set, rep thoải mái rồi gán cho học viên.",
  seriesTemplateAdminHint: "Lưu nội dung series này vào thư viện series mẫu dùng chung cho mọi phòng tập. Chỉ dùng được bài tập trong thư viện chung.",
  updateSeriesTemplateConfirm: "Ghi đè nội dung bản mẫu bằng series này? Các series đã sao chép trước đó không bị ảnh hưởng.",
  seriesTemplateCustomExercise: "Series có bài tập riêng của phòng tập. Hãy đổi sang bài trong thư viện chung trước khi lưu thành mẫu.",
  adminSeriesTemplatesHint: "Series mẫu đang hiển thị được mọi head coach và coach nhìn thấy và sao chép. Để sửa bài tập, mở mẫu trong trình soạn series rồi bấm \"Cập nhật mẫu\".",
  adminSeriesTemplatesCta: "Quản lý series mẫu (buổi tập đơn) cho mọi phòng tập",
  editSeriesTemplateContentHint: "Mẫu được sao chép vào phòng tập đã chọn để sửa bằng trình soạn series.",
  minutesPerWorkout: "Phút/buổi",
  tplCat_strength: "Sức mạnh",
  tplCat_hypertrophy: "Tăng cơ",
  tplCat_fat_loss: "Giảm mỡ",
  tplCat_corrective: "Chỉnh tư thế",
  tplCat_mobility: "Linh hoạt",
  tplCat_office: "Dân văn phòng",
  tplLevel_beginner: "Người mới",
  tplLevel_intermediate: "Trung cấp",
  tplLevel_advanced: "Nâng cao",
  tplLevel_all: "Mọi trình độ",
  tplEquip_gym: "Phòng gym",
  tplEquip_dumbbells: "Tạ đơn",
  tplEquip_home: "Tại nhà",
  tplEquip_none: "Không dụng cụ",
  // install + offline
  installApp: "Cài app lên điện thoại",
  installAppHint: "Mở nhanh từ màn hình chính, toàn màn hình như app thật, xem được cả khi mất mạng.",
  installNow: "Cài đặt",
  installIosSteps: "Trong Safari: bấm nút Chia sẻ (hình vuông có mũi tên lên) ở thanh dưới, rồi chọn “Thêm vào MH chính”.",
  installManual: "Mở menu ⋮ của trình duyệt và chọn “Cài đặt ứng dụng” hoặc “Thêm vào màn hình chính”.",
  installed: "App đã được cài trên thiết bị này.",
  later: "Để sau",
  offlineBanner: "Đang offline · đang xem dữ liệu đã lưu lần trước",
  offlineTitle: "Bạn đang offline",
  offlineBody: "Trang này chưa được lưu trên máy. Những trang bạn đã mở trước đó vẫn xem được khi mất mạng.",
  retry: "Thử lại",
  // rewrite (SPA) only
  loadFailed: "Không tải được dữ liệu.",
  pageNotFound: "Không tìm thấy trang này.",
  goHome: "Về trang chủ",
  // user management, coach overview, shared programs
  users: "Người dùng",
  adminUsersCta: "Xem tất cả tài khoản: vai trò, phòng, coach và học viên",
  searchUsers: "Tìm theo tên, username, SĐT, email",
  allRoles: "Mọi vai trò",
  allWorkspaces: "Mọi phòng",
  filter: "Lọc",
  usersFound: "{n} người dùng",
  tempPassword: "Mật khẩu tạm",
  userNoWorkspace: "Chưa thuộc phòng nào",
  prevPage: "Trang trước",
  nextPage: "Trang sau",
  createdOn: "Ngày tạo",
  lastSignIn: "Đăng nhập gần nhất",
  neverSignedIn: "Chưa đăng nhập lần nào",
  memberSince: "Tham gia từ",
  openClientPage: "Mở hồ sơ học viên",
  openCoachSchedule: "Xem lịch dạy và học viên",
  sessionsThisWeek: "Tuần này: {n} buổi dạy · {done} đã xong",
  clientsCount: "học viên",
  neverTrained: "Chưa tập buổi nào",
  trainedToday: "Hôm nay",
  trainedYesterday: "Hôm qua",
  trainedDaysAgo: "{n} ngày trước",
  nextSession: "Buổi tới",
  lastWorkout: "Tập gần nhất",
  adherence28: "4 tuần qua",
  needsAttention: "Cần chú ý",
  needsAttentionHint: "Học viên bỏ tập từ 7 ngày trở lên hoặc hoàn thành dưới 60% số buổi trong 4 tuần qua.",
  noMyClients: "Bạn chưa phụ trách học viên nào.",
  teachingSessions: "Buổi dạy",
  teachingHours: "Giờ dạy",
  teachingSchedule: "Lịch dạy",
  clientsTraining: "Lịch tập học viên",
  teachingScheduleHint: "Các buổi coach này trực tiếp dạy trong tuần.",
  clientsTrainingHint: "Mọi buổi tập của học viên coach này phụ trách, kể cả buổi tự tập.",
  noSessionsThisWeek: "Không có buổi nào trong tuần này.",
  openInSchedule: "Mở trên lịch chung",
  secondaryCoach: "Coach phụ",
  sharedProgram: "Chương trình chung của phòng",
  sharedPrograms: "Chương trình chung của phòng",
  sharedProgramsHint: "Head coach chia sẻ cho cả phòng. Nhân bản để chỉnh cho từng học viên.",
  myPrograms: "Của tôi",
  otherCoachesPrograms: "Của coach khác",
  programFor: "Dành cho",
  onlyCreatorEditsProgram: "Chỉ người tạo và head coach được sửa chương trình này. Hãy nhân bản để chỉnh cho học viên của bạn.",
  programCopied: "Đã nhân bản. Đây là bản của bạn: đổi bài, set, rep cho hợp với học viên rồi gán lịch.",
  copiedFromProgram: "Nhân bản từ:",
  cloneProgram: "Nhân bản để chỉnh sửa",
  cloneProgramHint: "Tạo bản riêng của bạn (có bản sao các buổi tập). Chọn học viên để gắn bản này cho người đó.",
  noClientTag: "Không gắn học viên",
  cloneAction: "Nhân bản",
  sharedProgramOn: "Mọi coach trong phòng thấy chương trình này ở mục chung và có thể nhân bản.",
  sharedProgramHint: "Đưa chương trình lên mục chung để các coach dùng và nhân bản.",
  unshareProgram: "Bỏ chia sẻ",
  shareProgram: "Chia sẻ",
  // progress tracking
  navProgress: "Tiến bộ",
  progress: "Tiến bộ",
  exercise: "Bài tập",
  addGoal: "Đặt mục tiêu",
  goalKind: "Loại mục tiêu",
  goalStart: "Bắt đầu",
  goalStartHint: "Để trống: lấy số đo gần nhất",
  goalTarget: "Mục tiêu",
  goalDeadline: "Hạn",
  goal_weight: "Cân nặng",
  goal_fat_mass: "Khối lượng mỡ",
  goal_body_fat_pct: "% mỡ",
  goal_muscle_mass: "Khối lượng cơ",
  goal_waist: "Vòng eo",
  goal_strength: "Sức mạnh (1RM ước tính)",
  goal_consistency: "Tập đều",
  goal_consistency_hint: "Số tuần liên tiếp hoàn thành ít nhất 90% số buổi đã lên lịch.",
  goalPickExercise: "Chọn bài tập cho mục tiêu sức mạnh.",
  goalNeedsTarget: "Nhập giá trị mục tiêu.",
  goalReached: "Đã đạt mục tiêu! Coach sẽ cùng bạn đặt mốc tiếp theo.",
  markAchieved: "Đã đạt",
  dropGoal: "Bỏ mục tiêu",
  noGoalsCoach: "Chưa có mục tiêu. Đặt 1–3 mục tiêu đo được để học viên thấy đường về đích.",
  noGoalsClient: "Coach chưa đặt mục tiêu cho bạn.",
  weeksUnit: "tuần",
  weekShort: "tuần",
  sinceDate: "từ {d}",
  projNeedData: "Cần ít nhất 3 lần đo trong 3 tuần để dự báo ngày đạt mục tiêu.",
  projCurrent: "Theo nhịp hiện tại ({pace}): đạt khoảng {from} – {to}.",
  projDisciplined: "Nếu tập đủ ≥ 90% buổi: khoảng {date}.",
  projDisciplinedSooner: "Nếu tập đủ ≥ 90% buổi: khoảng {date}, sớm hơn {n} tuần.",
  projEstimate: "(ước tính)",
  projKeepGoing: "Bạn đang tập rất đều ({pct}% số buổi). Giữ nhịp này là về đích đúng hẹn.",
  projGoodWeak: "Những tuần tập đủ buổi: {good}; tuần bỏ buổi: {weak}.",
  projWrongWay: "Đang đi ngược mục tiêu ({pace}). Cùng coach xem lại ăn uống và lịch tập.",
  projFlat: "Nhịp hiện tại quá chậm để dự báo. Tập đều hơn sẽ thấy khác biệt rõ.",
  projTooFast: "Đang thay đổi nhanh hơn mức an toàn: dễ mất cơ và khó giữ lâu. Coach sẽ điều chỉnh.",
  projAfterDeadline: "Theo nhịp này sẽ trễ hạn {d}.",
  paceNow: "Nhịp hiện tại",
  paceDisciplined: "Tập đủ buổi",
  strength: "Sức mạnh",
  e1rmHint: "1RM ước tính từ set tốt nhất mỗi tuần (công thức Epley, set 1–12 rep). Chấm vàng là kỷ lục.",
  noStrengthYet: "Chưa có dữ liệu tạ để tính sức mạnh.",
  bestLabel: "đỉnh",
  recentRecords: "Kỷ lục 30 ngày qua",
  records30: "Kỷ lục 30 ngày",
  attendance28: "Tập đủ 4 tuần",
  pickKeyLifts: "Chọn bài chính (tối đa 5)",
  pickKeyLiftsHint: "Bài chính hiện đầu tiên và dùng để phát hiện chững lại. Không chọn thì app lấy 3 bài tập nhiều nhất.",
  weeklySets: "Số set mỗi nhóm cơ (7 ngày)",
  weeklySetsHint: "Vùng tô là {lo}–{hi} set/tuần, khoảng thường dùng để phát triển cơ. Xám: thiếu, đỏ: có thể quá tải.",
  bodyComposition: "Thành phần cơ thể",
  fatShort: "Mỡ",
  muscleShort: "Cơ",
  skeletalMuscle: "Cơ xương (SMM)",
  fatMass: "Khối lượng mỡ",
  visceralFat: "Mỡ nội tạng",
  bmr: "BMR",
  bodyWater: "Nước",
  inbodyScore: "Điểm InBody",
  scansCount: "{n} lần đo",
  inbodyTip: "Đo cùng điều kiện mỗi lần (buổi sáng, trước khi ăn và tập) để số liệu so sánh được.",
  inbodyScan: "Kết quả InBody",
  manualMeasurement: "Đo tay",
  inbodyFormHint: "Chép từ phiếu InBody: cân nặng, % mỡ và các ô bên dưới. Ô nào không có thì để trống.",
  printReport: "In / Lưu PDF",
  newRecords: "Kỷ lục mới ở {n} bài!",
  pr_e1rm: "1RM ước tính",
  pr_weight: "Tạ nặng nhất",
  pr_reps: "Nhiều rep nhất",
  previousBest: "trước:",
  flag_stalled: "{ex}: chững 4 tuần, chưa vượt đỉnh cũ ({v}% dưới đỉnh). Gợi ý: đổi dải rep, thêm 1 set hoặc deload 1 tuần.",
  flag_dropping: "{ex}: tụt {v}% so với 4 tuần trước. Hỏi về giấc ngủ, ăn uống, căng thẳng; cân nhắc giảm tải.",
  flag_loss_too_fast: "Cân nặng giảm {v} kg/tuần, nhanh hơn 1% cân nặng/tuần: nguy cơ mất cơ. Tăng kcal hoặc protein.",
  flag_wrong_way: "Cân nặng / mỡ đang đi ngược mục tiêu ({v} kg/tuần). Xem lại nhật ký ăn và số buổi tập.",
  flag_wellbeing_down: "Năng lượng và giấc ngủ giảm 3 lần check-in liên tiếp. Nên hỏi thăm và giảm tải.",
  flag_stale_measurement: "Chưa đo lại 4 tuần. Hẹn đo InBody hoặc cân để cập nhật dự báo.",
  flagShort_stalled: "Chững lại",
  flagShort_dropping: "Tụt sức",
  flagShort_loss_too_fast: "Giảm quá nhanh",
  flagShort_wrong_way: "Ngược mục tiêu",
  flagShort_wellbeing_down: "Mệt mỏi",
  flagShort_stale_measurement: "Lâu chưa đo",
  clientsProgressing: "{n}/{total} học viên có kỷ lục trong 30 ngày",
  clientsFlagged: "{n} cần chú ý",
  streakNow: "Chuỗi hiện tại: {n}/{target} tuần",
  setMeasure: "Đo bằng",
  repsOrSec: "Rep / giây",
  startTimer: "Bắt đầu {n}s",
  startTimerPlain: "Bấm giờ",
  stopTimer: "Dừng",
  repsOptional: "Rep (nếu đếm)",
  workTimer: "Đang tập",
  doneEarly: "Xong",
  kcalOptional: "kcal (không bắt buộc)",
  sessionRpeOptional: "Độ mệt 1-10 (không bắt buộc)",
  trainNow: "Tập ngay",
  trainNowHint: "Tự tập, với PT, bài nhanh, cardio, HIIT theo video…",
  trainPlannedToday: "Buổi coach đã xếp hôm nay",
  trainHow: "Hôm nay bạn tập thế nào?",
  trainMode_strength: "Tự tập",
  trainMode_pt: "Tập với PT",
  trainMode_speedy: "Bài nhanh",
  trainMode_cardio: "Cardio",
  trainMode_hiit: "HIIT / theo video",
  trainMode_mobility: "Giãn cơ / Yoga",
  trainMode_other: "Khác",
  trainModeHint_strength: "Chọn bài của gym, bài mẫu hoặc tập lại buổi cũ",
  trainModeHint_pt: "PT trong gym hoặc bên ngoài",
  trainModeHint_speedy: "Bài 40 phút trở xuống",
  trainModeHint_cardio: "Chạy, đạp xe, bơi… ghi thời gian, km, nhịp tim",
  trainModeHint_hiit: "Dán link YouTube và tập theo",
  trainModeHint_mobility: "Giãn cơ, yoga, phục hồi",
  trainModeHint_other: "Lớp nhóm, thể thao, leo núi…",
  trainWhat: "Tập bài gì?",
  trainFree: "Không theo bài cụ thể",
  trainFreeHint: "Bấm giờ trong app rồi ghi lại thời gian, kcal",
  trainFromGym: "Bài coach chia sẻ",
  trainRepeat: "Tập lại buổi trước",
  trainFromTemplates: "Bài mẫu",
  sessionTitle: "Tên buổi tập",
  sessionTitleHint: "Không bắt buộc, mặc định là tên bài",
  startNow: "Bắt đầu",
  alreadyTrained: "Đã tập xong? Chỉ ghi lại",
  alreadyTrainedHint: "Ghi buổi đã tập, kể cả ngày trước đó (tối đa 60 ngày).",
  cardioType: "Loại cardio",
  cardio_run: "Chạy bộ",
  cardio_walk: "Đi bộ nhanh",
  cardio_bike: "Đạp xe",
  cardio_swim: "Bơi",
  cardio_row: "Chèo thuyền (máy)",
  cardio_elliptical: "Máy elliptical",
  cardio_stairs: "Leo cầu thang",
  minutesTrained: "Số phút tập",
  distanceKm: "Quãng đường (km)",
  avgHr: "Nhịp tim TB",
  sessionRpe: "Độ mệt (RPE)",
  saveSession: "Lưu buổi tập",
  trainer: "Huấn luyện viên",
  trainerOutside: "PT bên ngoài (nhập tên)",
  trainerName: "Tên PT",
  trainerNameHint: "Chỉ cần khi PT không có trong gym",
  followVideo: "Tập theo video",
  videoLink: "Link video",
  videoLinkHint: "Ví dụ một bài HIIT trên YouTube. App chỉ lưu link.",
  videoTitle: "Tên video",
  minShort: "phút",
  hourShort: "g",
  activity_strength: "Tập tạ",
  activity_speedy: "Bài nhanh",
  activity_cardio: "Cardio",
  activity_hiit: "HIIT",
  activity_mobility: "Giãn cơ / Yoga",
  activity_other: "Khác",
  withTrainer: "với {name}",
  selfTrained: "Tự tập",
  trainingTime: "Thời gian tập",
  logThisSession: "Ghi lại buổi tập",
  editSessionDetails: "Sửa thời gian, kcal, độ mệt",
  shareWithClients: "Chia sẻ cho học viên tự tập",
  sharedWithClients: "Học viên đang thấy bài này",
  shareWithClientsHint: "Học viên của gym chọn được bài này trong Tập ngay. Họ tập trên bản sao riêng, bài gốc không đổi.",
  share: "Chia sẻ",
  stopSharing: "Ngừng chia sẻ",
  journal: "Nhật ký tập",
  journalView_day: "Ngày",
  journalView_week: "Tuần",
  journalView_month: "Tháng",
  journalView_year: "Năm",
  totalTime: "Tổng giờ tập",
  activeDays: "Ngày có tập",
  volumeLifted: "Tổng khối lượng",
  distance: "Quãng đường",
  avgPerSession: "TB mỗi buổi",
  streakDays: "{n} ngày tập liên tiếp",
  byActivity: "Theo kiểu tập",
  byWho: "Tập với ai",
  context_program: "Theo chương trình",
  context_coach: "Coach xếp lịch",
  context_pt: "Với PT",
  context_self: "Tự tập",
  noTrainingThisDay: "Ngày này chưa có buổi tập.",
  perExerciseHistory: "Lịch sử theo từng bài tập",
};

export type Dict = typeof vi;
export type DictKey = keyof Dict;

const en: Dict = {
  appName: "Iron Spotter",
  appSlogan: "Discipline Over Regret",
  appSloganFull: "Pain of discipline or Pain of regret",
  showPassword: "Show password",
  hidePassword: "Hide password",
  rememberMe: "Remember me",
  forgotPassword: "Forgot password?",
  forgotPasswordTitle: "Forgot password",
  forgotPasswordIntro: "For security, a password can only be reset by the person who manages your account. Meet or call them as listed below.",
  forgotClientTitle: "Client",
  forgotClientBody: "Contact your coach or the head coach of your gym.",
  forgotCoachTitle: "Coach",
  forgotCoachBody: "Contact the head coach of your gym.",
  forgotHeadCoachTitle: "Head coach",
  forgotHeadCoachBody: "Contact the system administrator.",
  forgotPasswordAfter: "You will get your username and a temporary password. On your next login, the app asks you to set a new password.",
  backToLogin: "Back to login",
  login: "Log in",
  logout: "Log out",
  username: "Username",
  password: "Password",
  newPassword: "New password",
  confirmPassword: "Confirm password",
  changePassword: "Change password",
  mustChangePassword: "This is your first login. Please set a new password.",
  passwordMismatch: "Passwords do not match.",
  passwordTooShort: "Password must be at least 8 characters.",
  invalidLogin: "Wrong username or password.",
  save: "Save",
  saved: "Saved",
  cancel: "Cancel",
  create: "Create",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  back: "Back",
  search: "Search",
  all: "All",
  none: "None",
  notAllowed: "You are not allowed to do this.",
  navHome: "Home",
  navClients: "Clients",
  navExercises: "Exercises",
  navTeam: "Team",
  navSettings: "Settings",
  navMe: "Me",
  admin: "System admin",
  role_head_coach: "Head coach",
  role_coach: "Coach",
  role_client: "Client",
  workspaces: "Gyms",
  newWorkspace: "Create gym",
  workspaceName: "Gym name",
  slug: "Short code (used in URLs)",
  logoUrl: "Logo URL",
  primaryColor: "Primary color",
  branding: "Gym branding",
  headCoach: "Head coach",
  personalWorkspace: "Personal workspace (freelance coach)",
  noWorkspace: "You are not in any gym yet. Contact an administrator.",
  fullName: "Full name",
  phone: "Phone",
  contactEmail: "Contact email",
  accountCreated: "Account created",
  passwordReset: "Password reset",
  sendCredentials: "Send login details",
  sendSms: "Send by SMS",
  sendEmail: "Send by email",
  copy: "Copy",
  copied: "Copied",
  credentialsNote: "The password is shown only once. The user must change it on first login.",
  credentialsMessage: "Hi {name}, your Iron Spotter account:\nLog in: {url}\nUsername: {username}\nTemporary password: {password}",
  resetPassword: "Reset password",
  usernameTaken: "That username is taken.",
  usernameInvalid: "Username: 3–32 chars, lowercase letters, digits, dot, dash.",
  team: "Team",
  addCoach: "Add coach",
  addHeadCoach: "Add head coach",
  existingUser: "Existing account? Enter username",
  deactivate: "Deactivate",
  activate: "Reactivate",
  inactive: "Inactive",
  clients: "Clients",
  myClients: "Mine",
  newClient: "Add client",
  primaryCoach: "Primary coach",
  coaches: "Coaches",
  birthDate: "Birth date",
  sex: "Sex",
  male: "Male",
  female: "Female",
  other: "Other",
  height: "Height (cm)",
  goals: "Goals",
  injuries: "Injuries / notes",
  coachNotes: "Internal notes",
  profile: "Profile",
  noClients: "No clients yet.",
  bodyMetrics: "Body metrics",
  addMeasurement: "Log measurement",
  measuredOn: "Date",
  weight: "Weight",
  bodyFat: "Body fat %",
  neck: "Neck",
  shoulders: "Shoulders",
  chest: "Chest",
  armLeft: "Left arm",
  armRight: "Right arm",
  waist: "Waist",
  hips: "Hips",
  thighLeft: "Left thigh",
  thighRight: "Right thigh",
  calf: "Calf",
  note: "Note",
  optionalHint: "All optional, fill in what you have.",
  history: "History",
  exportCsv: "Export CSV",
  noMeasurements: "No measurements yet.",
  trend: "Trend",
  exercises: "Exercise library",
  newExercise: "Add exercise",
  muscle: "Muscle",
  primaryMuscles: "Primary muscles",
  secondaryMuscles: "Secondary muscles",
  equipment: "Equipment",
  level: "Level",
  category: "Category",
  instructions: "Instructions",
  youtubeUrl: "YouTube link",
  exerciseImages: "Images",
  exerciseImagesHint: "Paste image links (https://), one per line. An uploaded image goes first; the app shows up to 2 images.",
  uploadExerciseImage: "Upload an image",
  imageUrlInvalid: "Invalid image link (it must start with https://).",
  exerciseImageTooLarge: "The image is still too large after compression (max 300 KB). Try another image.",
  nameEn: "English name",
  nameVi: "Vietnamese name",
  tags: "Tags (comma separated)",
  globalLibrary: "Shared library",
  gymLibrary: "This gym only",
  measure: "Measured by",
  measure_reps: "Reps",
  measure_time: "Time",
  measure_distance: "Distance",
  noResults: "No exercises found.",
  oneStepPerLine: "One step per line",
  source: "Source",
  prev: "Previous",
  next: "Next",
  language: "Language",
  unit: "Weight unit",
  personal: "Personal",
  dashboardStaff: "Today",
  statClients: "Clients",
  statCoaches: "Coaches",
  statMeasurements7d: "Measurements, last 7 days",
  navSchedule: "Schedule",
  navLibrary: "Library",
  navHistory: "History",
  series: "Series",
  newSeries: "New series",
  seriesName: "Series name",
  purpose: "Purpose",
  muscleTags: "Muscle groups",
  proNote: "Pro note",
  addBlock: "Add exercise",
  addExerciseToBlock: "Pair another exercise",
  addSet: "Add set",
  remove: "Remove",
  moveUp: "Up",
  moveDown: "Down",
  block_single: "Single",
  block_superset: "Superset",
  block_triset: "Triset",
  block_giant: "Giant set",
  block_circuit: "Circuit",
  rounds: "Rounds",
  restAfterBlock: "Rest after group (s)",
  setType: "Set type",
  set_warmup: "Warm-up",
  set_working: "Working",
  set_drop: "Drop set",
  set_failure: "To failure",
  reps: "Reps",
  repsHint: "8, 8-12 or AMRAP",
  seconds: "Seconds",
  load: "Intensity",
  load_none: "None",
  load_kg: "Weight",
  load_pct_1rm: "%1RM",
  load_rm: "RM",
  load_rpe: "RPE",
  load_rir: "RIR",
  tempo: "Tempo",
  tempoHint: "4 chars eccentric/pause/concentric/pause, X = explosive (e.g. 31X0)",
  rest: "Rest",
  restSec: "Rest (s)",
  partial: "Partial",
  partial_none: "None",
  partial_partial: "Partial only",
  partial_full_partial: "Full + partial",
  partialOnly: "Partial",
  fullPlusPartial: "Full + partial",
  partialReps: "Partial reps",
  partialNote: "Partial range",
  pickExercise: "Pick an exercise",
  duplicate: "Duplicate",
  noSeries: "No series yet.",
  onlyCreatorEdits: "Only the creator can edit this series.",
  setsCount: "sets",
  exercisesCount: "exercises",
  schedule: "Schedule",
  assignSeries: "Schedule a session",
  date: "Date",
  time: "Time",
  slot: "Session of the day",
  slotN: "Session {n}",
  noSessions: "No sessions yet.",
  upcoming: "Upcoming",
  today: "Today",
  prevWeek: "Previous week",
  nextWeek: "Next week",
  clash: "Coach time clash",
  status_planned: "Planned",
  status_in_progress: "In progress",
  status_completed: "Done",
  status_skipped: "Skipped",
  editSession: "Edit this session only",
  deleteSession: "Delete session",
  startWorkout: "Start workout",
  continueWorkout: "Continue workout",
  endWorkout: "End workout",
  workoutDone: "Workout completed",
  setOf: "Set {n}/{total}",
  previous: "Last time",
  skip: "Skip",
  coachNote: "Coach note",
  exerciseHistory: "Exercise history",
  howTo: "How to",
  tapForDetails: "Tap an exercise to see how to do it",
  openExercisePage: "Open exercise page",
  noInstructions: "No detailed instructions for this exercise yet. Ask your coach.",
  workoutNoteLabel: "Coach note for this workout",
  cueForYou: "Your coach's cue",
  cueForClient: "Technique cue for this client",
  cueHint: "The client sees this cue in every workout with this exercise.",
  cuePlaceholder: "e.g. Knees out, down to parallel, 8 kg dumbbells",
  cueSaved: "Cue saved",
  noHistory: "No history yet.",
  overviewMinutes: "Minutes",
  trainingHistory: "Training history",
  markSkipped: "Mark as skipped",
  sessionsLabel: "Sessions",
  editingSessionCopy: "You are editing this session only; the template stays unchanged.",
  backToSession: "Back to session",
  leaveWorkout: "Leave workout",
  pauseTitle: "Pause this workout?",
  pauseBody: "You've logged {done} of {total} sets. They're saved, so you can come back and continue anytime.",
  saveAndLeave: "Save and leave",
  keepTraining: "Keep training",
  discardWorkout: "Discard workout",
  discardTitle: "Discard this workout?",
  discardBody: "The {n} logged sets will be deleted and won't count toward history or progress. The session goes back to not started. This can't be undone.",
  discardConfirm: "Delete and discard",
  restartWorkout: "Start over",
  restartTitle: "Start over?",
  restartBody: "The {n} logged sets will be deleted and the clock restarts from 0. This can't be undone.",
  restartConfirm: "Delete and start over",
  resumeTitle: "You have an unfinished workout",
  resumeBody: "Started at {time} · {done} of {total} sets logged.",
  finishTitle: "Finish workout?",
  finishSummary: "{done}/{total} sets · {min} min",
  finishMissing: "{n} sets aren't logged yet; they'll be left out.",
  finishEmpty: "You haven't logged any sets. Log at least one set to save the workout, or discard it if you're not training today.",
  finishNote: "Note for your coach (optional)",
  saveWorkout: "Save workout",
  actionFailed: "Couldn't save that, please try again.",
  video: "Video",
  setCol: "Set",
  logCol: "Log",
  navNutrition: "Nutrition",
  nutrition: "Nutrition",
  protein: "Protein",
  carbs: "Carbs",
  fat: "Fat",
  fiber: "Fiber (g)",
  water: "Water (ml)",
  kcal: "kcal",
  dayType: "Applies to",
  dayType_all: "Every day",
  dayType_training: "Training days",
  dayType_rest: "Rest days",
  trainingDay: "Training day",
  restDay: "Rest day",
  effectiveFrom: "Effective from",
  nutritionTargets: "Nutrition targets",
  newTarget: "New target",
  dailyTotals: "Whole day",
  mealsPlan: "Per-meal breakdown (optional)",
  addMealRow: "Add meal",
  mealName: "Meal name",
  mealPresets: "Breakfast,Lunch,Snack,Dinner",
  noTarget: "Your coach hasn't set nutrition targets yet.",
  noTargetStaff: "No nutrition targets for this client yet.",
  setTargets: "Set targets",
  kcalFromMacros: "Macros are in grams. Leave kcal blank to calculate it (4/4/9).",
  logMeal: "Log a meal",
  mealSlot: "Meal",
  otherMeal: "Other",
  foodName: "Food",
  photoOptional: "Photo (optional)",
  takePhoto: "Take / choose photo",
  removePhoto: "Remove photo",
  photoTooLarge: "Photo is too large (max 5 MB).",
  photoType: "Only JPG, PNG or WebP photos are accepted.",
  eaten: "Eaten",
  remaining: "Left",
  target: "Target",
  noMeals: "No meals logged for this day.",
  mealEmpty: "Enter at least a food name, macros or a photo.",
  comments: "Comments",
  writeComment: "Write a comment…",
  send: "Send",
  checkIns: "Weekly check-ins",
  checkIn: "Check-in",
  weekOf: "Week of {date}",
  energy: "Energy",
  sleep: "Sleep",
  stress: "Stress",
  hunger: "Hunger",
  digestion: "Digestion",
  ratingHint: "Rate 1–5 (1 = low, 5 = high).",
  trainingAdherence: "Training adherence (%)",
  nutritionAdherence: "Nutrition adherence (%)",
  wins: "Wins this week",
  struggles: "Struggles",
  questions: "Questions for your coach",
  submitCheckIn: "Submit check-in",
  checkInDue: "You haven't checked in this week",
  checkInDone: "Checked in this week",
  reviewed: "Reviewed",
  pendingReview: "Awaiting review",
  markReviewed: "Mark as reviewed",
  pendingCheckIns: "Check-ins to review",
  noCheckIns: "No check-ins yet.",
  weekSummary: "This week in numbers",
  avgWeight: "Avg weight",
  sessionsDone: "Sessions done",
  avgKcal: "Avg kcal/day",
  daysLogged: "Days with meals",
  viewAll: "View all",
  unknown: "Something went wrong. Please check the values.",
  programs: "Programs",
  program: "Program",
  newProgram: "New program",
  programName: "Program name",
  description: "Description",
  noPrograms: "No programs yet.",
  phase: "Phase",
  addPhase: "Add phase",
  phaseName: "Phase name",
  weeks: "Weeks",
  weeksN: "{n} weeks",
  dayCycle: "Day cycle (repeats)",
  cycleHint: "The day cycle repeats until the phase's weeks are over. 7 days = a weekly schedule.",
  addDay: "Add day",
  restOption: "Rest",
  dayN: "Day {n}",
  dayLabel: "Label (e.g. Push)",
  duplicatePhase: "Duplicate phase",
  phaseWorkoutsHint: "Each phase has its own workouts: editing one here does not change other phases.",
  programWorkouts: "Program workouts",
  newWorkout: "New workout…",
  editWorkout: "Edit workout",
  workoutNamePrompt: "Workout name (e.g. Push, Pull, Legs, Chest + Triceps)",
  programWorkoutBanner: "This workout belongs to the program {program}. Changes apply to future assignments of the program.",
  backToProgram: "Back to program",
  applyToPhase: "Apply to {n} remaining {workout} sessions",
  applyToPhaseHint: "Copies this session's exercises, sets, reps, loads and tempo to the client's upcoming {workout} sessions in the current phase.",
  appliedToPhase: "Applied to the remaining sessions in this phase.",
  coach: "Coach",
  dow1: "Mon",
  dow2: "Tue",
  dow3: "Wed",
  dow4: "Thu",
  dow5: "Fri",
  dow6: "Sat",
  dow7: "Sun",
  scheduleWeekdays: "On weekdays",
  scheduleCycle: "Day cycle",
  trainingDaysHint: "Pick the training days and a time for each. Push → Pull → Legs… fall in order on those days; rest days of the cycle are skipped.",
  scheduleCycleHint: "Repeats the phase's day cycle exactly, rest days included, at one time.",
  previewSchedule: "Preview",
  coachBusy: "The coach is already booked at:",
  pickTrainingDays: "Pick at least one training day.",
  trainingTimes: "Training times",
  changeTimes: "Change times",
  changeTimesHint: "Changes the time of upcoming sessions from the chosen date. Training weekdays stay the same; use the calendar to move days.",
  calendar: "Calendar",
  moveHere: "Move here",
  moveSession: "Move",
  swapSession: "Swap",
  pickTargetDay: "Tap the day to move it to",
  pickSwapSession: "Tap the day with the session to swap with",
  shiftLater: "Push later sessions back one day",
  shiftLaterHint: "For a missed day: this session and the ones after it move to the next training day, in the same order.",
  noSessionThisDay: "No session.",
  dayView: "Day",
  weekView: "Week",
  allCoaches: "All coaches",
  minutesShort: "min",
  duration: "Duration",
  sessionsCount: "sessions",
  weekViewHint: "Sessions starting in each hour. Tap to open that day. The — row counts sessions without a time.",
  cycleSummary: "{s} sessions / {d} days · {total} sessions in this phase",
  phasesCount: "phases",
  assignProgram: "Assign program",
  startDate: "Start date",
  startPhase: "Start at phase",
  currentPhase: "Current phase",
  weekOfN: "Week {w}/{n}",
  switchPhase: "Switch phase",
  fromDate: "From date",
  switchPhaseHint: "Sessions not started from this date are replaced by the new phase's schedule. Completed sessions are kept.",
  stopProgram: "Stop program",
  stopProgramHint: "Removes sessions not started from this date.",
  programActive: "Active",
  programStopped: "Stopped",
  programFinished: "Finished",
  programUpcoming: "Upcoming",
  phaseDone: "Done",
  phaseNow: "Now",
  phaseNext: "Next",
  viewProgram: "View program",
  programDeleted: "The original program was deleted, so phases can no longer be switched.",
  phaseDayN: "{phase} · Day {n}",
  // program templates
  templateLibrary: "Program templates",
  templateLibraryHint: "Ready-made programs by Iron Spotter. Copy one into your gym to edit it and assign it to clients.",
  templateLibraryCta: "PPL, bro split, full body, form fixes, flat feet, hip mobility, office workers…",
  noTemplates: "No templates yet.",
  perWeekN: "{n} sessions/week",
  minutesN: "~{n} min",
  cloneTemplate: "Copy to my gym",
  cloneTemplateHint: "Creates a new program of yours in this gym. The template itself does not change.",
  exerciseMissing: "not in the library",
  templateCloned: "Copied from the template. This program is yours: change exercises, sets and reps freely, then assign it.",
  clonedFromTemplate: "Copied from template:",
  templateAdmin: "Template library (admin)",
  templateAdminHint: "Saves this program to the template library shared by every gym. Only shared-library exercises can be used.",
  updateTemplate: "Update template \"{name}\"",
  updateTemplateConfirm: "Overwrite the template with this program? Programs copied from it earlier are not affected.",
  publishAsNewTemplate: "Save as a new template",
  templateSaved: "Saved to the template library. A new template stays a draft until you publish it on the admin page.",
  templateCustomExercise: "This program uses gym-only exercises. Swap them for shared-library exercises before saving it as a template.",
  adminTemplatesHint: "Published templates are visible to every head coach and coach, who can copy them. To change a template's workouts, open it in the program builder and press \"Update template\".",
  adminTemplatesCta: "Manage the program templates for every gym",
  templatePublished: "Published",
  templateDraft: "Draft",
  templateCategory: "Category",
  templateLevel: "Level",
  templateEquipment: "Equipment",
  sessionsPerWeek: "Sessions/week",
  minutesPerSession: "Minutes/session",
  sortOrder: "Order",
  templatePublishedHint: "Visible to head coaches and coaches",
  editTemplateContent: "Edit the template's workouts",
  editTemplateContentHint: "The template is copied into the selected gym so you can edit it with the program builder.",
  openInBuilder: "Open in the builder",
  deleteTemplate: "Delete template {name}",
  // series templates
  seriesTemplateLibrary: "Series from the legends",
  seriesTemplateLibraryHint: "Ready-made workouts modelled on the methods of legendary athletes and coaches. Copy one into your gym to edit it; the original always stays as it is.",
  seriesTemplateLibraryCta: "Arnold, Dorian Yates, Mike Mentzer, Ronnie Coleman, 5/3/1, Starting Strength, Westside…",
  noSeriesTemplates: "No series templates yet.",
  inspiredBy: "Inspired by",
  cloneSeriesTemplateHint: "Creates a new series of yours in this gym. The template itself does not change.",
  seriesTemplateCloned: "Copied from the template. This series is yours: change exercises, sets and reps freely, then assign it.",
  seriesTemplateAdminHint: "Saves this series to the series template library shared by every gym. Only shared-library exercises can be used.",
  updateSeriesTemplateConfirm: "Overwrite the template with this series? Series copied from it earlier are not affected.",
  seriesTemplateCustomExercise: "This series uses gym-only exercises. Swap them for shared-library exercises before saving it as a template.",
  adminSeriesTemplatesHint: "Published series templates are visible to every head coach and coach, who can copy them. To change the exercises, open the template in the series builder and press \"Update template\".",
  adminSeriesTemplatesCta: "Manage the series templates (single workouts) for every gym",
  editSeriesTemplateContentHint: "The template is copied into the selected gym so you can edit it with the series builder.",
  minutesPerWorkout: "Minutes per workout",
  tplCat_strength: "Strength",
  tplCat_hypertrophy: "Muscle gain",
  tplCat_fat_loss: "Fat loss",
  tplCat_corrective: "Corrective",
  tplCat_mobility: "Mobility",
  tplCat_office: "Office workers",
  tplLevel_beginner: "Beginner",
  tplLevel_intermediate: "Intermediate",
  tplLevel_advanced: "Advanced",
  tplLevel_all: "All levels",
  tplEquip_gym: "Gym",
  tplEquip_dumbbells: "Dumbbells",
  tplEquip_home: "At home",
  tplEquip_none: "No equipment",
  // install + offline
  installApp: "Install the app",
  installAppHint: "Open it from your home screen, full screen like a real app, even without a connection.",
  installNow: "Install",
  installIosSteps: "In Safari: tap the Share button (square with an up arrow) in the bottom bar, then “Add to Home Screen”.",
  installManual: "Open the browser menu ⋮ and choose “Install app” or “Add to Home screen”.",
  installed: "The app is installed on this device.",
  later: "Later",
  offlineBanner: "Offline · showing data saved earlier",
  offlineTitle: "You're offline",
  offlineBody: "This page isn't saved on this device yet. Pages you opened before still work without a connection.",
  retry: "Try again",
  // rewrite (SPA) only
  loadFailed: "Could not load the data.",
  pageNotFound: "This page does not exist.",
  goHome: "Go to home",
  // user management, coach overview, shared programs
  users: "Users",
  adminUsersCta: "Every account: role, gym, coaches and clients",
  searchUsers: "Search name, username, phone, email",
  allRoles: "All roles",
  allWorkspaces: "All gyms",
  filter: "Filter",
  usersFound: "{n} users",
  tempPassword: "Temporary password",
  userNoWorkspace: "Not in any gym",
  prevPage: "Previous",
  nextPage: "Next",
  createdOn: "Created",
  lastSignIn: "Last sign-in",
  neverSignedIn: "Never signed in",
  memberSince: "Member since",
  openClientPage: "Open client profile",
  openCoachSchedule: "See schedule and clients",
  sessionsThisWeek: "This week: {n} sessions led · {done} done",
  clientsCount: "clients",
  neverTrained: "No workout yet",
  trainedToday: "Today",
  trainedYesterday: "Yesterday",
  trainedDaysAgo: "{n} days ago",
  nextSession: "Next session",
  lastWorkout: "Last workout",
  adherence28: "Last 4 weeks",
  needsAttention: "Needs attention",
  needsAttentionHint: "Clients idle for 7+ days or who completed under 60% of their sessions in the last 4 weeks.",
  noMyClients: "You have no clients yet.",
  teachingSessions: "Sessions",
  teachingHours: "Hours",
  teachingSchedule: "Teaching",
  clientsTraining: "Clients' training",
  teachingScheduleHint: "Sessions this coach leads during the week.",
  clientsTrainingHint: "Every session of this coach's clients, including solo ones.",
  noSessionsThisWeek: "No sessions this week.",
  openInSchedule: "Open in the gym schedule",
  secondaryCoach: "Secondary coach",
  sharedProgram: "Gym shared program",
  sharedPrograms: "Gym shared programs",
  sharedProgramsHint: "Shared by the head coach. Copy one to tailor it for a client.",
  myPrograms: "Mine",
  otherCoachesPrograms: "Other coaches",
  programFor: "For",
  onlyCreatorEditsProgram: "Only the creator and the head coach can edit this program. Copy it to tailor it for your client.",
  programCopied: "Copied. This is your version: change exercises, sets and reps for the client, then schedule it.",
  copiedFromProgram: "Copied from:",
  cloneProgram: "Copy to edit",
  cloneProgramHint: "Makes your own version (with its own copies of the workouts). Pick a client to tag the copy for them.",
  noClientTag: "No client",
  cloneAction: "Copy",
  sharedProgramOn: "Every coach of the gym sees this program under shared programs and can copy it.",
  sharedProgramHint: "List this program under shared programs so coaches can use and copy it.",
  unshareProgram: "Stop sharing",
  shareProgram: "Share",
  // progress tracking
  navProgress: "Progress",
  progress: "Progress",
  exercise: "Exercise",
  addGoal: "Set a goal",
  goalKind: "Goal type",
  goalStart: "Start",
  goalStartHint: "Blank: latest measurement",
  goalTarget: "Target",
  goalDeadline: "Deadline",
  goal_weight: "Weight",
  goal_fat_mass: "Fat mass",
  goal_body_fat_pct: "Body fat %",
  goal_muscle_mass: "Muscle mass",
  goal_waist: "Waist",
  goal_strength: "Strength (estimated 1RM)",
  goal_consistency: "Consistency",
  goal_consistency_hint: "Weeks in a row with at least 90% of the scheduled sessions done.",
  goalPickExercise: "Pick an exercise for a strength goal.",
  goalNeedsTarget: "Enter a target value.",
  goalReached: "Goal reached! Your coach will set the next milestone with you.",
  markAchieved: "Reached",
  dropGoal: "Drop goal",
  noGoalsCoach: "No goals yet. Set 1–3 measurable goals so the client sees the road to the finish.",
  noGoalsClient: "Your coach has not set goals yet.",
  weeksUnit: "weeks",
  weekShort: "wk",
  sinceDate: "since {d}",
  projNeedData: "At least 3 measurements over 3 weeks are needed to project a date.",
  projCurrent: "At the current pace ({pace}): around {from} – {to}.",
  projDisciplined: "With ≥ 90% of sessions done: around {date}.",
  projDisciplinedSooner: "With ≥ 90% of sessions done: around {date}, {n} weeks sooner.",
  projEstimate: "(estimate)",
  projKeepGoing: "You train very consistently ({pct}% of sessions). Keep this pace and you arrive on time.",
  projGoodWeak: "Weeks with every session done: {good}; weeks with missed sessions: {weak}.",
  projWrongWay: "Moving away from the goal ({pace}). Review food and training with your coach.",
  projFlat: "The current pace is too slow to project. More consistent training will show.",
  projTooFast: "Changing faster than is safe: muscle loss is likely and it is hard to sustain. Your coach will adjust.",
  projAfterDeadline: "At this pace the {d} deadline will be missed.",
  paceNow: "Current pace",
  paceDisciplined: "Full attendance",
  strength: "Strength",
  e1rmHint: "Estimated 1RM from the best set each week (Epley, sets of 1–12 reps). Highlighted points are records.",
  noStrengthYet: "No weighted sets logged yet.",
  bestLabel: "best",
  recentRecords: "Records in the last 30 days",
  records30: "Records (30 days)",
  attendance28: "Attendance (4 weeks)",
  pickKeyLifts: "Pick key lifts (up to 5)",
  pickKeyLiftsHint: "Key lifts come first and drive stall detection. Without a pick, the 3 most trained lifts are used.",
  weeklySets: "Sets per muscle (7 days)",
  weeklySetsHint: "The band is {lo}–{hi} sets a week, a common range for muscle growth. Grey: too few, red: possibly too many.",
  bodyComposition: "Body composition",
  fatShort: "Fat",
  muscleShort: "Muscle",
  skeletalMuscle: "Skeletal muscle (SMM)",
  fatMass: "Fat mass",
  visceralFat: "Visceral fat",
  bmr: "BMR",
  bodyWater: "Body water",
  inbodyScore: "InBody score",
  scansCount: "{n} scans",
  inbodyTip: "Scan under the same conditions each time (morning, before eating and training) so results compare.",
  inbodyScan: "InBody scan",
  manualMeasurement: "Tape measure",
  inbodyFormHint: "Copy from the InBody sheet: weight, body fat % and the fields below. Leave blank what the sheet lacks.",
  printReport: "Print / Save PDF",
  newRecords: "New records on {n} lifts!",
  pr_e1rm: "Estimated 1RM",
  pr_weight: "Heaviest set",
  pr_reps: "Most reps",
  previousBest: "before:",
  flag_stalled: "{ex}: stalled for 4 weeks, below the earlier best ({v}%). Try another rep range, one more set, or a deload week.",
  flag_dropping: "{ex}: down {v}% on the 4 weeks before. Ask about sleep, food and stress; consider reducing load.",
  flag_loss_too_fast: "Weight falling {v} kg a week, faster than 1% of body weight: muscle loss risk. Raise calories or protein.",
  flag_wrong_way: "Weight / fat mass moving against the goal ({v} kg a week). Review the food log and attendance.",
  flag_wellbeing_down: "Energy and sleep fell in 3 check-ins in a row. Check in with them and reduce load.",
  flag_stale_measurement: "No measurement for 4 weeks. Book an InBody scan or weigh-in to update the projection.",
  flagShort_stalled: "Stalled",
  flagShort_dropping: "Losing strength",
  flagShort_loss_too_fast: "Losing too fast",
  flagShort_wrong_way: "Off goal",
  flagShort_wellbeing_down: "Run down",
  flagShort_stale_measurement: "Not measured",
  clientsProgressing: "{n}/{total} clients set a record in 30 days",
  clientsFlagged: "{n} need attention",
  streakNow: "Current streak: {n}/{target} weeks",
  setMeasure: "Measured by",
  repsOrSec: "Reps / sec",
  startTimer: "Start {n}s",
  startTimerPlain: "Start timer",
  stopTimer: "Stop",
  repsOptional: "Reps (optional)",
  workTimer: "Work",
  doneEarly: "Done",
  kcalOptional: "kcal (optional)",
  sessionRpeOptional: "Effort 1-10 (optional)",
  trainNow: "Train now",
  trainNowHint: "On your own, with a PT, quick workouts, cardio, HIIT videos…",
  trainPlannedToday: "Planned by your coach today",
  trainHow: "How are you training today?",
  trainMode_strength: "On my own",
  trainMode_pt: "With a PT",
  trainMode_speedy: "Quick workout",
  trainMode_cardio: "Cardio",
  trainMode_hiit: "HIIT / video",
  trainMode_mobility: "Mobility / yoga",
  trainMode_other: "Other",
  trainModeHint_strength: "Pick a gym workout, a template or repeat an earlier one",
  trainModeHint_pt: "A trainer from the gym or outside",
  trainModeHint_speedy: "Workouts of 40 min or less",
  trainModeHint_cardio: "Run, bike, swim… time, km, heart rate",
  trainModeHint_hiit: "Paste a YouTube link and follow along",
  trainModeHint_mobility: "Stretching, yoga, recovery",
  trainModeHint_other: "Classes, sports, climbing…",
  trainWhat: "Which workout?",
  trainFree: "No set workout",
  trainFreeHint: "Time it in the app, then record time and kcal",
  trainFromGym: "Shared by your coaches",
  trainRepeat: "Repeat an earlier workout",
  trainFromTemplates: "Templates",
  sessionTitle: "Session name",
  sessionTitleHint: "Optional; defaults to the workout's name",
  startNow: "Start",
  alreadyTrained: "Already trained? Just record it",
  alreadyTrainedHint: "Record a session you already did, also on an earlier day (up to 60 days back).",
  cardioType: "Type",
  cardio_run: "Running",
  cardio_walk: "Brisk walking",
  cardio_bike: "Cycling",
  cardio_swim: "Swimming",
  cardio_row: "Rowing",
  cardio_elliptical: "Elliptical",
  cardio_stairs: "Stair climber",
  minutesTrained: "Minutes",
  distanceKm: "Distance (km)",
  avgHr: "Avg heart rate",
  sessionRpe: "Effort (RPE)",
  saveSession: "Save session",
  trainer: "Trainer",
  trainerOutside: "Outside trainer (enter a name)",
  trainerName: "Trainer's name",
  trainerNameHint: "Only when the trainer is not in this gym",
  followVideo: "Follow a video",
  videoLink: "Video link",
  videoLinkHint: "For example a HIIT workout on YouTube. Only the link is saved.",
  videoTitle: "Video title",
  minShort: "min",
  hourShort: "h",
  activity_strength: "Strength",
  activity_speedy: "Quick workout",
  activity_cardio: "Cardio",
  activity_hiit: "HIIT",
  activity_mobility: "Mobility",
  activity_other: "Other",
  withTrainer: "with {name}",
  selfTrained: "On my own",
  trainingTime: "Training time",
  logThisSession: "Record this session",
  editSessionDetails: "Edit time, kcal and effort",
  shareWithClients: "Share with clients",
  sharedWithClients: "Shared with clients",
  shareWithClientsHint: "Clients of the gym can pick this workout under Train now. They train on their own copy; this workout never changes.",
  share: "Share",
  stopSharing: "Stop sharing",
  journal: "Training journal",
  journalView_day: "Day",
  journalView_week: "Week",
  journalView_month: "Month",
  journalView_year: "Year",
  totalTime: "Total time",
  activeDays: "Active days",
  volumeLifted: "Volume lifted",
  distance: "Distance",
  avgPerSession: "Avg per session",
  streakDays: "{n}-day streak",
  byActivity: "By activity",
  byWho: "How you trained",
  context_program: "Program",
  context_coach: "Scheduled by coach",
  context_pt: "With a PT",
  context_self: "On my own",
  noTrainingThisDay: "No training on this day.",
  perExerciseHistory: "History per exercise",
};

const dicts: Record<Locale, Dict> = { vi, en };

export function getDict(locale: Locale | null | undefined): Dict {
  return dicts[locale ?? "vi"] ?? vi;
}

export function fill(template: string, vars: Record<string, string>): string {
  return template.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
}
